
(() => {
  'use strict';
  const init = root => {
    if (root.dataset.hfcInitialized === 'true') return;
    root.dataset.hfcInitialized = 'true';
    const filters = Array.from(root.querySelectorAll('[data-hfc-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-hfc-goal]'));
    const status = root.querySelector('[data-hfc-filter-status]');
    root.querySelector('[data-hfc-filters]')?.removeAttribute('hidden');
    filters.forEach(button => button.addEventListener('click', () => {
      const goal = button.dataset.hfcFilter;
      filters.forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      let visible = 0;
      cards.forEach(card => { card.hidden = goal !== 'all' && card.dataset.hfcGoal !== goal; if (!card.hidden) visible++; });
      root.querySelector('.hfc-products')?.classList.toggle('is-filtered', goal !== 'all');
      if (status) status.textContent = `${visible} ${visible === 1 ? 'panel' : 'panels'} shown. ${button.textContent.trim()}.`;
    }));
    root.querySelectorAll('a[href="#hfc-panel-details"]').forEach(link => link.addEventListener('click', () => {
      const details = root.querySelector('#hfc-panel-details');
      if (details) details.open = true;
    }));

    const optionTable = root.querySelector('[data-hfc-option-matrix]');
    const optionButtons = Array.from(root.querySelectorAll('[data-hfc-option-filter]'));
    const optionControls = root.querySelector('[data-hfc-option-controls]');
    const optionStatus = root.querySelector('[data-hfc-option-status]');
    if (optionTable && optionButtons.length) {
      const selectOption = (selected, announce = true) => {
        optionTable.querySelectorAll('[data-hfc-option]').forEach(cell => {
          cell.hidden = selected !== 'all' && cell.dataset.hfcOption !== 'siphox' && cell.dataset.hfcOption !== selected;
        });
        optionTable.classList.toggle('is-pair', selected !== 'all');
        optionTable.querySelectorAll('[data-hfc-group-span]').forEach(cell => cell.colSpan = selected === 'all' ? 6 : 3);
        optionButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.hfcOptionFilter === selected)));
        if (announce && optionStatus) optionStatus.textContent = selected === 'all' ? 'All five service models shown.' : 'Showing SiPhox and ' + optionButtons.find(button => button.dataset.hfcOptionFilter === selected).textContent.trim() + '.';
      };
      optionControls?.removeAttribute('hidden');
      optionButtons.forEach(button => button.addEventListener('click', () => selectOption(button.dataset.hfcOptionFilter)));
      selectOption(window.matchMedia('(max-width: 900px)').matches ? 'lab' : 'all', false);
      const expandButton = root.querySelector('[data-hfc-option-expand]');
      if (expandButton) {
        const moreGroups = Array.from(root.querySelectorAll('[data-hfc-option-more]'));
        let expanded = root.dataset.hfcExpandComparison === 'true';
        const updateExpansion = () => {
          moreGroups.forEach(group => { group.hidden = !expanded; });
          expandButton.setAttribute('aria-expanded', String(expanded));
          expandButton.textContent = expanded ? 'Show collection overview' : 'Show all 8 advantages';
        };
        expandButton.removeAttribute('hidden'); updateExpansion();
        expandButton.addEventListener('click', () => {
          expanded = !expanded; updateExpansion();
          if (optionStatus) optionStatus.textContent = expanded ? 'All 8 comparison points shown.' : 'Three collection comparison points shown.';
        });
      }

    }
    const sticky = root.querySelector('[data-hfc-sticky]');
    const hero = root.querySelector('[data-hfc-hero]');
    if (sticky && hero && 'IntersectionObserver' in window) {
      let heroVisible = true;
      let closingReached = false;
      const updateSticky = () => sticky.classList.toggle('is-visible', !heroVisible && !closingReached);
      const observer = new IntersectionObserver(entries => { heroVisible = entries[0].isIntersecting; updateSticky(); }, {threshold: 0});
      observer.observe(hero);
      const closing = root.querySelector('.hfc-closing');
      if (closing) {
        const closingObserver = new IntersectionObserver(entries => {
          closingReached = entries[0].isIntersecting || entries[0].boundingClientRect.top < 0;
          updateSticky();
        }, {threshold: 0});
        closingObserver.observe(closing);
      }
    }
    const variantSelect = root.querySelector('[data-hfc-variant]');
    const buyButton = root.querySelector('[data-hfc-buy]');
    const price = root.querySelector('[data-hfc-product-price]');
    if (variantSelect && buyButton) {
      const update = () => {
        const option = variantSelect.options[variantSelect.selectedIndex];
        buyButton.disabled = !option.value || option.dataset.available !== 'true';
        buyButton.textContent = !option.value ? 'Choose an option' : option.dataset.available === 'true' ? 'Add to cart' : 'Sold out';
        if (price && option.dataset.price) price.textContent = option.dataset.price;
      };
      variantSelect.addEventListener('change', update); update();
    }
  };
  const initAll = scope => scope.querySelectorAll('[data-hfc-siphox]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document)); else initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
